'use strict'; //eslint-disable-line

angular
  .module('employeeEdit')
  .component('employeeEdit', {
    template: require('./employee-edit.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', '$routeParams', 'AuthService', 'envService', 'Upload',
      function EmployeeEditController($rootScope, $scope, $resource, $route, $location, $window, $translate, $routeParams, AuthService, envService, Upload) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'members';
        $rootScope.menu = 'employees';
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.loginMember = AuthService.loginMember();
        this.resetPassword = '';
        this.resetPasswordConfirm = '';
        this.resettingPassword = false;
        this.selectedAreas = [];
        this.modalAreas = [];
        this.modalCityId = '';
        this.modalQuery = '';
        this.modalSelectAll = false;
        this.detailer = {
          name: '',
          id: '',
          user_id: '',
          password: '',
          email: '',
          tel: '',
          profile_image: '',
          type: '1',
          tb_team_id: '-1',
          tb_city_id: '',
          commission: '0',
          gender: '',
          birth: '',
          working_hour: '',
          vehicle: '',
          no_wash_after_19: 'N',
          auto_direct: 'N',
          wash_start_hour: '-1',
          wash_end_hour: '-1',
          subscription_yn: 'N' };

        const isEnabled = (area) => area.enabled === true || area.enabled === 1 || area.enabled === '1';
        const errorHandler = (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        };
        const selectedIdSet = () => {
          const set = {};
          (this.selectedAreas || []).forEach((a) => { set[String(a.ID)] = true; });
          return set;
        };

        this.removeSelectedArea = (area) => {
          this.selectedAreas = (this.selectedAreas || []).filter(a => String(a.ID) !== String(area.ID));
        };
        this.modalCheckedCount = () => (this.modalAreas || []).filter(a => a._checked).length;
        this.syncModalSelectAll = () => {
          const list = this.modalAreas || [];
          this.modalSelectAll = list.length > 0 && list.every(a => a._checked);
        };
        this.toggleModalSelectAll = () => {
          (this.modalAreas || []).forEach((a) => { a._checked = !!this.modalSelectAll; });
        };
        this.loadModalAreas = () => {
          if (!this.modalCityId) {
            this.modalAreas = [];
            return;
          }
          const already = selectedIdSet();
          $resource(`${APIURL}/admin/maps/areas/foremployee`).get({
            TB_CITY_ID: this.modalCityId,
            TB_USER_ID: $routeParams.tbUserId,
          }, (data) => {
            this.modalAreas = (data.areas || [])
              .filter(a => !already[String(a.ID)])
              .map(a => Object.assign({}, a, { _checked: false }));
            this.modalSelectAll = false;
            this.modalQuery = '';
          }, errorHandler);
        };
        this.openAreaModal = () => {
          this.modalCityId = this.detailer.tb_city_id || (this.cities[0] && String(this.cities[0].ID)) || '';
          this.loadModalAreas();
          jQuery('#modal-add-areas').modal('show');
        };
        this.confirmModalAreas = () => {
          const toAdd = (this.modalAreas || []).filter(a => a._checked).map(a => ({
            ID: a.ID,
            NAME: a.NAME,
            CITY_NAME: a.CITY_NAME,
            TB_CITY_ID: a.TB_CITY_ID,
          }));
          const already = selectedIdSet();
          toAdd.forEach((a) => {
            if (!already[String(a.ID)]) {
              this.selectedAreas.push(a);
            }
          });
          jQuery('#modal-add-areas').modal('hide');
        };
        this.loadSelectedAreas = () => {
          $resource(`${APIURL}/admin/maps/areas/foremployee`).get({
            TB_USER_ID: $routeParams.tbUserId,
          }, (data) => {
            this.selectedAreas = (data.areas || []).filter(isEnabled).map(a => ({
              ID: a.ID,
              NAME: a.NAME,
              CITY_NAME: a.CITY_NAME,
              TB_CITY_ID: a.TB_CITY_ID,
            }));
          }, errorHandler);
        };

        this.submitResetPassword = () => {
          const tbUserId = $routeParams.tbUserId || this.detailer.id;
          if (!tbUserId) {
            alert($translate.instant('알수 없는 에러 입니다.'));
            return;
          }
          if (!this.resetPassword || this.resetPassword.length < 4) {
            alert($translate.instant('비밀번호를 입력해주세요.'));
            return;
          }
          if (this.resetPassword !== this.resetPasswordConfirm) {
            alert($translate.instant('비밀번호가 일치하지 않습니다.'));
            return;
          }
          if (!confirm($translate.instant('비밀번호를 재설정 하시겠습니까?'))) {
            return;
          }
          this.resettingPassword = true;
          $resource(`${APIURL}/admin/employees/${tbUserId}/password`).save(
            { password: this.resetPassword },
            () => {
              this.resetPassword = '';
              this.resetPasswordConfirm = '';
              this.resettingPassword = false;
              alert($translate.instant('수정되었습니다.'));
            },
            (err) => {
              this.resettingPassword = false;
              errorHandler(err);
            }
          );
        };

        this.submit = () => {
          if (this.detailer.profile_image.length < 1) {
            alert($translate.instant('프로필 이미지를 등록 해주세요.'));
            return;
          }
          if (this.detailer.name.length < 1) {
            alert($translate.instant('이름을 입력해 주세요.'));
            return;
          }
          if (!this.detailer.user_id || String(this.detailer.user_id).trim().length < 1) {
            alert($translate.instant('아이디를 입력해주세요.'));
            return;
          }
          if (this.detailer.email && String(this.detailer.email).trim().length > 0
              && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(this.detailer.email).trim())) {
            alert($translate.instant('올바른 이메일을 입력해주세요.'));
            return;
          }
          if (this.detailer.tel.length < 1) {
            alert($translate.instant('전화번호를 입력해주세요.'));
            return;
          }
          if (this.detailer.gender.length < 1) {
            alert($translate.instant('성별을 선택해주세요.'));
            return;
          }
          if (this.detailer.birth.length < 1) {
            alert($translate.instant('생년월일을 입력해주세요'));
            return;
          }
          if (this.detailer.tb_city_id.length < 1) {
            alert($translate.instant('세차 도시를 선택해주세요.'));
            return;
          }
          if (this.detailer.no_wash_after_19.length < 1) {
            alert($translate.instant('저녁7시이후세차 가능여부를 선택해주세요.'));
            return;
          }
          if (this.detailer.working_hour.length < 1) {
            alert($translate.instant('세차가능시간을 입력해주세요.'));
            return;
          }
          if (this.detailer.vehicle.length < 1) {
            alert($translate.instant('이동수단을 입력해주세요.'));
            return;
          }
          if (this.detailer.commission.length < 1) {
            alert($translate.instant('수익율을 입력해주세요.'));
            return;
          }
          if (isNaN(parseInt(this.detailer.commission, 10)) || parseInt(this.detailer.commission, 10) < 0 || parseInt(this.detailer.commission, 10) > 100) {
            alert($translate.instant('올바른 수익율을 입력해주세요(0~100)'));
            return;
          }
          const parameters = jQuery.extend({}, this.detailer);
          parameters.user_id = String(this.detailer.user_id).trim();
          parameters.email = (this.detailer.email || '').toString().trim();
          parameters.commission = parseInt(this.detailer.commission, 10);
          parameters.areas = (this.selectedAreas || []).map(a => a.ID);
          if (parameters.type === '1' && this.loginMember.COUNTRY_CODE === 'KR') { // in_house.employeekorea
            parameters.no_wash_after_19 = 'N';
            parameters.wash_start_hour = parameters.wash_start_hour === '-1' ? null : parameters.wash_start_hour;
            parameters.wash_end_hour = parameters.wash_end_hour === '-1' ? null : parameters.wash_end_hour;
          } else { // independent contractors
            parameters.wash_start_hour = parameters.wash_start_hour === '-1' ? null : parameters.wash_start_hour;
            parameters.wash_end_hour = parameters.wash_end_hour === '-1' ? null : parameters.wash_end_hour;
          }
          $resource(`${APIURL}/admin/employees/${this.detailer.id}`).save(parameters, () => {
            $location.path('/employees');
          }, errorHandler);
        };
        this.upload = (files) => {
          console.log(files);
          if (files && files.length) {
            const file = files[0];
            Upload.upload({
              url: `${APIURL}/admin/file/profile`,
              file,
            }).progress((evt) => {
              const progressPercentage = parseInt((100.0 * evt.loaded) / evt.total, 10);
              console.log(`progress: ${progressPercentage}% ${evt.config.file.name}`);
            }).success((data, status, headers, config) => {
              console.log(`file ${config.file.name}uploaded. Response: ${data}`);
              console.log(data);
              this.detailer.profile_image = data.url;
            });
          }
        };

        $resource(`${APIURL}/admin/employees/:tb_user_id`, { tb_user_id: $routeParams.tbUserId }).get().$promise
          .then((data) => {
            const keysToLowerCase = (obj) => {
              Object.keys(obj).forEach((key) => {
                const k = key.toLowerCase();
                if (k !== key) {
                  obj[k] = obj[key];
                  delete obj[key];
                }
              });
              return (obj);
            };
            this.detailer = keysToLowerCase(data.employee);
            this.detailer.type = this.detailer.employee_type;
            this.detailer.user_id = this.detailer.user_id || '';
            this.detailer.email = this.detailer.email || '';
            if (this.detailer.tb_team_id === undefined || this.detailer.tb_team_id === null) {
              this.detailer.tb_team_id = '-1';
            } else {
              this.detailer.tb_team_id = this.detailer.tb_team_id.toString();
            }
            if (this.detailer.wash_start_hour) {
              this.detailer.wash_start_hour = this.detailer.wash_start_hour.toString();
            } else {
              this.detailer.wash_start_hour = '-1';
            }
            if (this.detailer.wash_end_hour === null || this.detailer.wash_end_hour === undefined) {
              this.detailer.wash_end_hour = '-1';
            } else {
              this.detailer.wash_end_hour = this.detailer.wash_end_hour.toString();
            }
            return $resource(`${APIURL}/admin/meta/employee`).get().$promise;
          })
          .then((data) => {
            this.teams = data.teams;
            this.cities = data.cities || [];
            if (this.detailer.tb_city_id === undefined || this.detailer.tb_city_id === null || this.detailer.tb_city_id === '') {
              this.detailer.tb_city_id = this.cities.length ? String(this.cities[0].ID) : '';
            } else {
              this.detailer.tb_city_id = String(this.detailer.tb_city_id);
            }
            this.loadSelectedAreas();
          })
          .catch(errorHandler);
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/employee/employee-edit/employee-edit.component.js